
import FarmMenuItem from "@/components/Sidebar/FarmMenuItem.vue";
import FarmInfo from "@/components/Sidebar/FarmInfo.vue";
import RecentParcels from "@/components/Sidebar/RecentParcels.vue";
import SidebarMenu from "@/components/Sidebar/SidebarMenu.vue";
import ParcelItem from "@/components/Parcel/ParcelItem.vue";
import ParcelMenuItem from "@/components/Sidebar/ParcelMenuItem.vue";
import FarmPickerMenu from "@/components/Sidebar/FarmPickerMenu.vue";
import { gettersInstance, isMobile } from "../../lib/util";
import Component, { mixins } from "vue-class-component";
import { MixedVue } from "@/vue";
import { Watch } from "vue-property-decorator";

const StoreGetters = gettersInstance([
  "user",
  "userEmail",
  "userFarms",
  "sharedFarms",
  "currentFarm",
  "currentFarmId",
  "selectedParcel",
  "rasterKind",
  "farmsWithSeasons",
]);

@Component({
  name: "AppSidebar",
  components: {
    FarmPickerMenu,
    ParcelMenuItem,
    ParcelItem,
    SidebarMenu,
    RecentParcels,
    FarmInfo,
    FarmMenuItem,
  },
})
export default class AppSidebar extends mixins(MixedVue, StoreGetters) {
  static components: {
    FarmPickerMenu: typeof FarmPickerMenu;
    ParcelMenuItem: typeof ParcelMenuItem;
    ParcelItem: typeof ParcelItem;
    SidebarMenu: typeof SidebarMenu;
    RecentParcels: typeof RecentParcels;
    FarmInfo: typeof FarmInfo;
    FarmMenuItem: typeof FarmMenuItem;
  };

  showFarmPicker: boolean = false;

  get showCloseButton() {
    if (!isMobile()) {
      return true;
    } else {
      return this.currentFarm?.parcel_count > 0;
    }
  }
  @Watch("$route")
  $routeChanged() {
    this.showFarmPicker = false;
  }

  toggleFarmPicker(value: boolean) {
    this.showFarmPicker = value;
    this.$emit("farmPicker", value);
  }

  closeSidebar() {
    this.$store.commit("setShowAppSidebar", false);
  }
}
